"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const sulu_1 = require("../../api/sulu");
const configuration_1 = __importDefault(require("../apis/configuration/sulu/configuration"));
class SuluNewsTeaser {
    api = new sulu_1.NewsTeaserApi(configuration_1.default);
    newsTeaserItems = new Map();
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            newsTeaserItems: mobx_1.observable,
            loadNewsTeaserItems: mobx_1.action.bound,
        });
    }
    loadNewsTeaserItems(locale, industryId) {
        return this.api.getNewsTeaserItems({ locale, industryId }).then((newsTeaserItems) => {
            this.newsTeaserItems.set(locale, newsTeaserItems);
            return newsTeaserItems;
        });
    }
    get(locale) {
        return this.newsTeaserItems.get(locale) ?? null;
    }
}
__decorate([
    bind_decorator_1.default
], SuluNewsTeaser.prototype, "get", null);
exports.default = new SuluNewsTeaser();
